import { msgTypes } from "constants/msgTypes";
import { RouteType } from "constants/RouteType";
import { AuthService } from "services/auth/AuthService";

export class MemberLoginService {
  // constructor() {}

  // Save Login Data

  static getLoginDetails = async () => {
    const url = RouteType.ADMIN + RouteType.MEMBER_LOGIN;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(msgTypes.EMPTY_STR)
    );
    return response;
  };
}
